import * as Sentry from "@sentry/vue";
import router from "@/router";
import { createApp } from "vue";

const app = createApp();
Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay({
            blockAllMedia: JSON.parse(process.env.VUE_APP_SENTRY_REPLAY_BLOCK_ALL_MEDIA),
            maskAllInputs: JSON.parse(process.env.VUE_APP_SENTRY_REPLAY_MASK_ALL_INPUTS),
            maskAllText: JSON.parse(process.env.VUE_APP_SENTRY_REPLAY_MASK_ALL_TASK)
        })
    ],

    tracesSampleRate: parseFloat(process.env.VUE_APP_SENTRY_TRACE_SAMPLE_RATE),

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [process.env.VUE_APP_APP_URL],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: parseFloat(process.env.VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE),
    replaysOnErrorSampleRate: parseFloat(process.env.VUE_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE),

    environment: process.env.NODE_ENV,

    enabled: false
});

export { Sentry };